import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiClient } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        try {
            const res = await apiClient.get('/auth/me', { validateStatus: (s) => s < 500 });
            if (res.status === 200) setUser(res.data); else setUser(null);
        } catch (_) {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip /me — AuthCallback handles it.
        if (window.location.hash?.includes('session_id=')) {
            setLoading(false);
            return;
        }
        checkAuth();
    }, [checkAuth]);

    const logout = async () => {
        try { await apiClient.post('/auth/logout'); } catch (_) {}
        setUser(null);
        window.location.href = '/';
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, checkAuth, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
